import a from "./ghl-ui.es1235.js";
import o from "./ghl-ui.es728.js";
var t = a(o, "WeakMap");
const p = t;
export {
  p as default
};
